import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState }  from 'react'
import TapSelect from '../../../components/ui/TapSelect';
import { Modal } from 'bootstrap';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import uuid from 'react-uuid';

const UpdateStatusModal = forwardRef(({loadListingTblData, clearCheckedIds, getFuelFeedInDetail}, ref) => {

    const formDataUrl       =   IAM_API_BASE_URL_2 + "/counterlog/fuelfeedin_status_form_data";
    const updateStatusUrl   =   IAM_API_BASE_URL_2 + "/counterlog/fuelfeedin_status_update";
    const accessToken       =   useSelector(state => state.auth.access_token);

    const modalId           =   uuid();

    const initialData       =   {
        feedin_ids              :   [],
        remarks                 :   "",
        status                  :   "",
    }
    const [updateStatusData, setUpdateStatusData]   =   useState(initialData);
    const [isEdit, setIsEdit]                       =   useState(null);

    const [formData, setFormData]                   =   useState({
        loading     :   false,
        status      :   [],
        btnLoading  :   false 
    });

    const modalElem     =   useRef(null);
    const modal         =   useRef(null);

    useEffect(() => {
        modalElem.current = document.getElementById(modalId);
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);

    useImperativeHandle(ref, () => ({
        initModalHandler: (feedin_ids, statusValue, transaction_id) => {
            setUpdateStatusData(pre => ({...pre, feedin_ids, status: statusValue}));
            transaction_id && setIsEdit(transaction_id);
            if(formData.status.length === 0 || statusValue !== updateStatusData.status) {
                formDataApi(statusValue);
            }
            modalOpen();
        },
    }));

    const formDataApi       =   (statusValue)  =>  {
        setFormData(pre => ({...pre, loading : true}));
        HttpAPICall.withAthorization('GET', formDataUrl, accessToken, {}, {}, (resp) => {
            let respData = resp.data;
            const status =  respData.status.filter(s => s.key === statusValue).map(s => ({label : s.status, value: s.key}));
            setFormData(pre => ({
                ...pre,
                status 
            }));
        }).then(() => setFormData(pre => ({...pre, loading : false})));
    }

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose = () => {
        if (modal.current) { modal.current.hide(); }
    };

    const handleInput   =   (e) => {
        setUpdateStatusData(pre => ({...pre, [e.target.name] : e.target.value}))
    }
    const handleSelect  =   (option) => {
        setUpdateStatusData(pre => ({...pre, status : option.value}))
    }
    


    const handleFormSubmit  =   (e) => {
        e.preventDefault();

        setFormData(pre => ({...pre, btnLoading : true}));
        HttpAPICall.withAthorization('POST', updateStatusUrl, accessToken, {}, updateStatusData, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            setUpdateStatusData(initialData);       
            modalClose();    
            loadListingTblData(); 
            clearCheckedIds();
            isEdit && getFuelFeedInDetail()
        }).then(() => { 
            setFormData(pre => ({...pre, btnLoading : false}))
            setIsEdit(false);
        });

    }

  return (
    <>
        <div className="modal fade" id={modalId} tabIndex="-1" ref={modalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Update Status</h5>
                        <button type="button" className="btn-close" onClick={modalClose}></button>
                    </div>
                    <div className="modal-body">
                        {
                            formData.loading 
                            ? <Loader/>
                            :
                            <form id="updateStatusForm" onSubmit={handleFormSubmit}>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label require">Status</label>
                                    </div>
                                    <div className="col-sm-5">
                                        <TapSelect
                                            options={formData.status}
                                            changeEvent={(selectOption) => handleSelect(selectOption)}
                                            value={formData.status.find(s => s.value === updateStatusData.status)}
                                            isSearchable={true}
                                            isClearable={false}
                                            required={true}
                                            placeholder="Please Select Status"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label require">Remarks</label>
                                    </div>
                                    <div className="col-sm-5">
                                    <textarea
                                        required={true}
                                        name="remarks"
                                        value={updateStatusData.remarks}
                                        onChange={(e) => handleInput(e)}
                                        className="form-control"
                                        style={{ height: "95px" }}
                                    />
                                    </div>
                                </div>
                            </form>
                        }
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" disabled={formData.loading || formData.btnLoading} onClick={modalClose}>
                            Close
                        </button>
                        <button type="submit" form="updateStatusForm" disabled={formData.loading || formData.btnLoading} className="btn btn-primary">Update {formData.btnLoading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
})

export default UpdateStatusModal